import React, { useEffect } from 'react';
import { bool, func, object, oneOf, shape } from 'prop-types';

import ImageWithdrawOrder from '@assets/Image/Trading/WithdrawOrder.svg';

import { Container, Row, Col, Button, Typography } from '@ajaibid/components';
import { PopUpCenterV2 } from 'Component/PopUp';

import { transformOrderDetail } from '../StockAmend/adapter';
import { useSubmitWithdraw } from './hooks';
import useEventTracker from './tracker';

const PopUpStockWithdraw = (props) => {
  const { data, show, onHide } = props;
  const orderDetail = transformOrderDetail(data);

  const { isLoading, submitWithdraw } = useSubmitWithdraw({
    orderDetail,
    onSuccess: () => onHide(),
    onDtError: () => {}, // TODO: fill this
  });

  const { eventShowPopupWithdraw, eventClickConfirmWithdraw, eventClickCancelWithdraw } =
    useEventTracker({ orderDetail });

  useEffect(() => {
    if (!show) return;
    eventShowPopupWithdraw();
  }, [show]);

  const handleOnHide = () => {
    eventClickCancelWithdraw();
    onHide();
  };

  const handleSubmitWithdraw = () => {
    eventClickConfirmWithdraw();
    submitWithdraw();
  };

  return (
    <PopUpCenterV2 size="md" show={show} onHide={handleOnHide}>
      <img src={ImageWithdrawOrder} alt="withdraw-order" />
      <Container padding="8px 48px 32px">
        <Typography type="body" bold align="center" margin={0}>
          Batalkan Order?
        </Typography>
        <Typography type="body" align="center" marginTop={8}>
          Setelah dibatalkan, order akan hilang secara permanen.
        </Typography>
      </Container>
      <Row gutters={8} align="between">
        <Col>
          <Button
            fluid
            variant="naked"
            size="lg"
            loading={isLoading}
            onClick={handleSubmitWithdraw}
          >
            Batalkan
          </Button>
        </Col>
        <Col>
          <Button fluid variant="primary" size="lg" onClick={handleOnHide}>
            Tidak
          </Button>
        </Col>
      </Row>
    </PopUpCenterV2>
  );
};

PopUpStockWithdraw.propTypes = {
  data: shape({
    accountType: oneOf(['REGULAR', 'DAY_TRADING', 'MARGIN_TRADING']),
    orderType: oneOf(['LIMIT', 'AUTO']),
    orderDetail: object,
  }),
  show: bool,
  onHide: func,
};

PopUpStockWithdraw.defaultProps = {
  data: {
    accountType: 'REGULAR',
    orderType: 'LIMIT',
    orderDetail: {},
  },
  show: false,
  onHide: () => {},
};

export default PopUpStockWithdraw;
